import { createReducer } from '@reduxjs/toolkit';
// eslint-disable-next-line import/no-extraneous-dependencies
import {
  clearBasket,
  loginRequest, logout, passwordReset, registerRequest, resetPasswordApi,
} from '../actions/user';
import { addToUserBasket, removeFromUserBasket } from '../actions/basketActions';
import { changeProfile } from '../actions/userAccount';

const initialState = {
  user: JSON.parse(localStorage.getItem('user')) || {},
  cart: localStorage.getItem('UserBasket') !== 'undefined' && JSON.parse(localStorage.getItem('UserBasket')) ? JSON.parse(localStorage.getItem('UserBasket')) : [],
  token: localStorage.getItem('token') || '',
  isAuth: Boolean(localStorage.getItem('token')),
};
export default createReducer(initialState, (builder) => {
  builder.addCase(registerRequest.fulfilled, (state, action) => {
    const { user, token, cart } = action.payload;
    if (token) {
      localStorage.setItem('token', token);
      localStorage.setItem('UserBasket', JSON.stringify(cart));
      localStorage.setItem('user', JSON.stringify(user));
    }
    return {
      ...state,
      token,
      user: {
        email: user.email,
        id: user.id,
      },
      cart,
      isAuth: true,
    };
  })
    .addCase(loginRequest.fulfilled, (state, action) => {
      // eslint-disable-next-line camelcase
      const { user, access_token, cart } = action.payload;
      // eslint-disable-next-line camelcase
      if (access_token) {
        localStorage.setItem('token', access_token);
      }
      localStorage.setItem('UserBasket', JSON.stringify(cart));
      localStorage.setItem('user', JSON.stringify(user));
      return {
        ...state,
        // eslint-disable-next-line camelcase
        token: access_token,
        user: {
          ...user,
        },
        cart,
        isAuth: true,
      };
    }).addCase(logout, () => {
      localStorage.removeItem('token');
      localStorage.removeItem('UserBasket');
      localStorage.removeItem('user');
      return {
        user: {
          email: '',
          id: '',
        },
        cart: [],
        token: null,
        isAuth: false,
      };
    }).addCase(addToUserBasket.fulfilled, (state, action) => {
      localStorage.setItem('UserBasket', JSON.stringify(action.payload));
      return {
        ...state,
        cart: action.payload,
      };
    })
    .addCase(removeFromUserBasket.fulfilled, (state, action) => {
      localStorage.setItem('UserBasket', JSON.stringify(action.payload.carts));
      return {
        ...state,
        cart: action.payload.carts,
      };
    })
    .addCase(passwordReset.fulfilled, (state, action) => {
      console.log(action);
    })
  // eslint-disable-next-line no-unused-vars
    .addCase(resetPasswordApi.fulfilled, (state, action) => {

    })
    .addCase(changeProfile.fulfilled, (state, action) => {
      const newUser = action.payload.data;
      localStorage.setItem('user', JSON.stringify(newUser));
      return {
        ...state,
        user: {
          ...newUser,
        },
      };
    })
    .addCase(clearBasket, (state) => {
      localStorage.removeItem('UserBasket');
      return {
        ...state,
        cart: [],
      };
    });
});
